export function getDefaultOptions() {
    return {
        classes: {
            isScrolledDown: `is-scrolled-down`,
        }
    };
}

export function initialize(_options = getDefaultOptions()) {
    console.log("Initializing scroll listener.");

    const options = _options;

    let isScrolled = false;
    let clatter = false;

    window.addEventListener('scroll', function() {
        if (!clatter) {
            window.requestAnimationFrame(function() {
                const scrollPosition = window.scrollY || window.pageYOffset;
                
                if (scrollPosition > 0 && !isScrolled) {
                    document.body.classList.add(options.classes.isScrolledDown);
                    isScrolled = true;
                } else if (scrollPosition === 0 && isScrolled) {
                    document.body.classList.remove(options.classes.isScrolledDown);
                    isScrolled = false;
                }
                
                clatter = false;
            });
            
            clatter = true;
        }
    });

    console.log("Scroll listener initialized.");
}